import { inject, Injectable } from '@angular/core';
import {
    ExternalTaskType,
    IInterpolationFragmentService,
    InterpolationFragment,
    InterpolationFragmentType,
    SystemEntity,
    TokenParts,
} from '@wdx/shared/utils';
import { ChecklistRoutingHelperService } from '../../../shared/services/checklist-routing/checklist-rouing.helper.service';

export const REGARDING_TYPE_TO_EXTERNAL_TASK_TYPE: Record<string, string> = {
    [SystemEntity.DocumentRequirement]: ExternalTaskType.DocumentRequirement,
    [SystemEntity.Party]: ExternalTaskType.Form,
    [SystemEntity.PartyRole]: ExternalTaskType.Form,
    [SystemEntity.IdentityCheck]: ExternalTaskType.IdentityVerification,
    [SystemEntity.Envelope]: ExternalTaskType.SignatureRequirement,
};

@Injectable({
    providedIn: 'root',
})
export class InterpolationFragmentService extends IInterpolationFragmentService {
    private checklistRoutingHelperService = inject(
        ChecklistRoutingHelperService,
    );

    convertTokenPartsToFragment(
        parts: TokenParts,
        entityId: string,
        regardingParts?: TokenParts,
    ): InterpolationFragment {
        const textFrgament = {
            type: InterpolationFragmentType.Text,
            value: parts.token,
        };
        if ([parts.name, parts.id, parts.type].every((item) => !item)) {
            return textFrgament;
        }

        if ([parts.name, parts.id, parts.type].every(Boolean)) {
            const entityType = parts.type as SystemEntity;
            const value = parts.name;
            const partsId = parts.id;

            const externalTaskType = REGARDING_TYPE_TO_EXTERNAL_TASK_TYPE[
                regardingParts?.type as SystemEntity
            ] as ExternalTaskType;

            if (!externalTaskType || entityType !== SystemEntity.ExternalTask) {
                return {
                    type: InterpolationFragmentType.Text,
                    value,
                    entityType,
                };
            }

            const routerLink =
                this.checklistRoutingHelperService.generateTaskRoute(
                    externalTaskType,
                    parts.id,
                );

            return {
                type: InterpolationFragmentType.Link,
                value,
                entityType,
                entityId: partsId,
                subEntityType: undefined,
                subEntityId: undefined,
                routerLink: routerLink,
            };
        }

        return textFrgament;
    }
}
